<template>
  <div class="input-phone">
    <RichInput v-model="internalData" :placeholder="placeholder || gettext('请输入')">
      <div slot="prepend" class="input-prepend">
        <span>{{ preText }}</span>
      </div>
    </RichInput>
  </div>
</template>

<script type="text/ecmascript-6">
import { Input as RichInput } from '@didi/rich-ui'

export default {
  name: 'InputPhone',
  components: {
    RichInput
  },
  props: {
    value: {
      required: true,
      type: String,
      default: ''
    },
    preText: {
      type: String,
      default: '+86'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      internalData: this.value
      // rules: {
      //   pattern: /^1{10}$/
      // },
      // messages: {
      //   pattern: this.gettext('首位必须是1')
      // }
    }
  },
  watch: {
    value (nVal) {
      this.internalData = nVal
    },
    internalData (nVal) {
      this.$emit('input', nVal)
      this.$emit('change', nVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-wrap {
  .form-item-content {
    .input-phone {
      .rich-input {
        display: flex;
      }
      .input-prepend {
        padding: 10px;
      }
    }
  }
}
</style>
